import { render, staticRenderFns } from "./StrukDetail.vue?vue&type=template&id=501d2a4f&scoped=true&"
import script from "./StrukDetail.vue?vue&type=script&lang=js&"
export * from "./StrukDetail.vue?vue&type=script&lang=js&"
import style0 from "./StrukDetail.vue?vue&type=style&index=0&id=501d2a4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501d2a4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
